export default __webpack_public_path__ + "static/media/excel.e4918523.png";